module.exports = __webpack_public_path__ + "img/espelcamp_logo.862884a9.png";